import { PostgrestResponse } from '@supabase/supabase-js';
import { IProdutos } from '../../../types/tables/IProdutos';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

export class ProdutosService extends BaseMultiTenantService<IProdutos> {
  constructor() {
    super('produtos', ['descricao', 'descricao_reduzida', 'ncm'], 'fk_id_organizacao')
  }

  /**
   * Busca produtos por categoria/grupo
   */
  async getByGrupo(organizationId: number, grupoId: number): Promise<PostgrestResponse<IProdutos[]>> {
    return await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('fk_id_grupo', grupoId)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('descricao');
  }

  /**
   * Busca produtos em estoque
   */
  async getEmEstoque(organizationId: number): Promise<PostgrestResponse<IProdutos[]>> {
    return await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('controle_estoque', true)
      .gt('quantidade_estoque', 0)
      .is('deleted_at', null)
      .order('descricao');
  }

  /**
   * Atualiza estoque do produto
   */
  async atualizarEstoque(organizationId: number, id: number, quantidade: number): Promise<void> {
    const { error } = await this.client
      .from(this.tableName)
      .update({ quantidade_estoque: quantidade })
      .eq('id', id)
      .eq(this.organizationIdField, organizationId)

    if (error) {
      throw new Error(`Erro ao atualizar estoque: ${error.message}`)
    }
  }
}

export const produtosService = new ProdutosService()
